import React from "react";
import PremiumResourcePage, { resourceMoney } from "../../../Components/Dashboard/PremiumResourcePage";

function PaymentsMade({ navigation }) {
  return (
    <PremiumResourcePage
      navigation={navigation}
      title="Payments Made"
      subtitle="Review outgoing vendor payments and references."
      createRoute="PaymentsMadeNew"
      createLabel="+ New Payment"
      fetchEndpoint="/fetchPurchaseRecords"
      totalKey="payment"
      columns={[
        { key: "paymentDate", label: "Date" },
        { key: "paymentNumber", label: "Payment #" },
        { key: "reference", label: "Reference" },
        { key: "vendorName", label: "Vendor Name" },
        { key: "paymentMode", label: "Mode" },
        { key: "payment", label: "Amount", className: "premium-money", render: (row) => resourceMoney(row.payment) },
      ]}
    />
  );
}

export default PaymentsMade;
